<nav class="navbar navbar-expand-lg nav-crev" [class.nav-scroll]="isSticky">
    <div class="container" >
        <a class="navbar-brand icon-img-100" [routerLink]="'/'">
            <img [src]="logo" alt="Logo" class="logo"style="width:200px">
        </a>
        <button
            class="navbar-toggler ms-auto"
            type="button"
            (click)="isCollapsed = !isCollapsed"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup" 
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="icon-bar"><i class="icofont icofont-navigation-menu"></i></span>
        </button>
        <div class="collapse navbar-collapse" [ngClass]="{'collapse': isCollapsed, 'navbar-collapse': true}" id="navbarNavAltMarkup">
            <ul class="navbar-nav me-auto xs-mt-20">
                <li class="nav-item"><a class="nav-link" (click)="scrollToSection('home')">{{'home'|translate}}</a></li>
                <li class="nav-item"><a class="nav-link" (click)="scrollToSection('features')">{{'features'|translate}}</a></li>
                <!--<li class="nav-item"><a class="nav-link" (click)="scrollToSection('team')">Team</a></li>-->
                <!--<li class="nav-item"><a class="nav-link" (click)="scrollToSection('services')">Services</a></li>-->
                <li class="nav-item"><a class="nav-link" (click)="scrollToSection('about')">{{'about'|translate}}</a></li>
                <!--<li class="nav-item"><a class="nav-link" (click)="scrollToSection('portfolio')">Portfolio</a></li>-->
                <!--<li class="nav-item"><a class="nav-link" (click)="scrollToSection('pricings')">Pricings</a></li>-->
                <!--<li class="nav-item"><a class="nav-link" (click)="scrollToSection('blog')">Blog</a></li>-->
                <li class="nav-item"><a class="nav-link" (click)="scrollToSection('contact')">{{'contact'|translate}}</a></li>
            </ul>
            <!-- Language dropdown -->
            <div class="dropdown ms-auto">
                <select class="form-select form-select-sm dropdown-toggle" (change)="changeLanguage($event)" aria-label="Select Language">
                    <option value="hr" selected>HR</option>
                    <option value="en">EN</option>
                </select>
            </div>
        </div>
    </div>
</nav>
